:host {
    display: block;
}

/* Error Handling */
.error {
    display:flex;
    flex-direction: column;
    align-items:center;
    margin-block-end:1rem;
    text-align:center;
}

.error .headline {
    font-size:clamp(2rem, 4dvw, 3rem);
    color: var(--color-primary, black);
}